class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Use querySelector on this element instead of document to scope to this instance
    this.toggleButton = this.querySelector('.facets-toggle-button');
    this.facetsWrapper = this.querySelector('.facets-wrapper');
    
    if (this.toggleButton && this.facetsWrapper) {
      this.setupAttributes();
      this.bindEvents();
      this.checkBreakpoint();
    }
  }

  setupAttributes() {
    // Ensure we have an ID for ARIA attributes
    if (!this.facetsWrapper.id) {
      this.facetsWrapper.id = 'facets-wrapper-' + Math.random().toString(36).substr(2, 9);
    }

    // Set up ARIA attributes
    this.toggleButton.setAttribute('aria-expanded', 'false');
    this.toggleButton.setAttribute('aria-controls', this.facetsWrapper.id);
  }

  bindEvents() {
    // Toggle button click
    this.toggleButton.addEventListener('click', () => this.toggleFacets());

    // Close on escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.closeFacets();
      }
    });

    // Handle resize
    window.addEventListener('resize', () => this.checkBreakpoint());

    // Close when clicking outside
    document.addEventListener('click', (event) => {
      if (this.isOpen && !this.contains(event.target)) {
        this.closeFacets();
      }
    });

    // Delegate clicks inside the component for explicit close controls
    this.addEventListener('click', (event) => {
      const closeEl = event.target.closest('[data-facets-close], .facets-close');
      if (closeEl && this.contains(closeEl)) {
        event.preventDefault();
        this.closeFacets();
      }
    });
  }

  get isOpen() {
    return this.toggleButton.getAttribute('aria-expanded') === 'true';
  }

  toggleFacets() {
    this.isOpen ? this.closeFacets() : this.openFacets();
  }

  openFacets() {
    this.toggleButton.setAttribute('aria-expanded', 'true');
    // Ensure only the outer wrapper is shown
    this.facetsWrapper.classList.add('show');
    // Remove stray 'show' on any nested wrappers to avoid overlay conflicts
    this.querySelectorAll('.facets-wrapper .facets-wrapper.show').forEach((el) => el.classList.remove('show'));
  }

  closeFacets() {
    this.toggleButton.setAttribute('aria-expanded', 'false');
    // Remove 'show' from all wrappers inside this component to guarantee hide
    this.querySelectorAll('.facets-wrapper.show').forEach((el) => el.classList.remove('show'));
  }

  checkBreakpoint() {
    const isMobile = window.innerWidth < 750;
    if (!isMobile) {
      // On desktop, facets are always visible
      this.facetsWrapper.classList.remove('show');
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }
  }
}

// Initialize the facets toggle only if not already defined
if (!customElements.get('facets-toggle')) {
  customElements.define('facets-toggle', FacetsToggle);
}